function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import React from "react";
import State from "../renderless/state";
import PropTypes from "prop-types";

var FormManager = function FormManager(_ref) {
  var data = _ref.data,
      disableFunc = _ref.disableFunc,
      _render = _ref.render,
      children = _ref.children,
      onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React.createElement(State, {
    initialState: data,
    render: function render(_ref2) {
      var state = _ref2.state,
          setState = _ref2.setState;
      var disable_func_result = disableFunc(state); // old version only returned booleans, so this code is to maintain compatability

      var is_obj = _typeof(disable_func_result) === "object";
      var is_disabled = is_obj ? disable_func_result.isDisabled : disable_func_result;
      var errors = is_obj ? disable_func_result.errors : {};
      var renderProp = typeof _render === "function" ? _render : children;

      var doTheSubmit = function doTheSubmit() {
        onSubmit(state, setState);
      };

      return renderProp({
        state: state,
        setState: setState,
        errors: errors,
        isDisabled: is_disabled,
        handleSubmit: doTheSubmit
      });
    }
  });
};

FormManager.propTypes = {
  data: PropTypes.object,
  disableFunc: PropTypes.func,
  children: PropTypes.func,
  render: PropTypes.func,
  onSubmit: PropTypes.func
};
FormManager.displayName = "FormManager";
export default FormManager;